import React from "react";
import IconBoxStyle11 from "../../IconBox/IconBoxStyle11";
import Spacing from "../../Spacing";

export default function ContactInfoSection({ sectionTitle }) {
  return (
    <div className="container">
      {/* <h2 className="cs_fs_72 mb-0">{sectionTitle}</h2> */}
      <Spacing md="70" lg="50" />
      <div className="row g-4 g-xl-3 g-xxl-5">
        <div className="col-xl-4">
          <div className="cs_iconbox cs_style_11 cs_radius_25">
            <div className="cs_iconbox_icon">
              <img src="/images/contact/icon_1.svg" alt="Icon" />
            </div>
            <div className="cs_iconbox_right">
              <h3 className="cs_iconbox_title cs_fs_24 mb-0">Phone</h3>
              <p className="cs_iconbox_subtitle mb-0 cs_heading_color space-x-0.5 flex flex-col">
                <a
                  href="tel:+913614516663"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  +91 3614516663 (Call)
                </a>
                <a
                  href="tel:+919707076232"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  +91 9707076232 (WA & Call)
                </a>
                <a
                  href="tel:+919707998887"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  +91 9707998887 (WA & Call)
                </a>
              </p>
              <p className="cs_iconbox_subtitle mb-0 cs_heading_color">
                10am-4pm, Mon-Fri, (except holidays)
              </p>
            </div>
          </div>
        </div>
        <div className="col-xl-4">
          <IconBoxStyle11
            title="Email"
            subTitle="info@nhwm.in"
            href="mailto:info@nhwm.in"
            iconSrc="/images/contact/icon_2.svg"
          />
        </div>
        <div className="col-xl-4">
          <IconBoxStyle11
            title="Location"
            subTitle="House No. 1, Karbi Namghar Path Khagen Mahanta Path, Hengrabari, near Karbi Namghar, Borbari, Guwahati, Assam 781036"
            href="https://www.google.com/maps/place/National+Healthcare+%26+Wellness+Mission/@26.150227,91.8098962,17z/data=!4m14!1m7!3m6!1s0x375a59aa64f75da1:0xa9fa61749a2b8496!2sNational+Healthcare+%26+Wellness+Mission!8m2!3d26.150227!4d91.8098962!16s%2Fg%2F11ny0tcys6!3m5!1s0x375a59aa64f75da1:0xa9fa61749a2b8496!8m2!3d26.150227!4d91.8098962!16s%2Fg%2F11ny0tcys6?entry=ttu&g_ep=EgoyMDI1MDYwNC4wIKXMDSoASAFQAw%3D%3D"
            iconSrc="/images/contact/icon_3.svg"
          />
        </div>
      </div>
      <Spacing md="35" />
      {/* Start Google Map */}
      <div className="cs_map">
        <iframe
          title="Google Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3581.426774742203!2d91.8098962!3d26.150227!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x375a59aa64f75da1%3A0xa9fa61749a2b8496!2sNational%20Healthcare%20%26%20Wellness%20Mission!5e0!3m2!1sen!2sin!4v1749284226978!5m2!1sen!2sin"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      {/* End Google Map */}
    </div>
  );
}
